import React, { useState, useContext } from 'react';
import { AppState } from "./Home";

import './userlist.css';
import UserListElement from './UserListElement';
import UserListMenu from './Components/ContextMenu/UserListMenu';

function UserList({ displayModal, sendMessage, characterId }) {
    const context = useContext(AppState);
    const { roomListMobs, roomListPlayers } = context;
    const [rightClickMenu, setRightClickMenu] = useState(null);

    const displayMenu = (e, pos, details) => {
        e.preventDefault();
        e.stopPropagation();
        const x = e.clientX;
        const y = e.clientY;
        setRightClickMenu({ x, y, pos, details });
    }

    const hideMenu = () => {
        setRightClickMenu(null);
    }

    return (
        <div className='userlist-panel' onClick={hideMenu}>
            <div className="userlist">
                {roomListMobs.map((details, index) => (<UserListElement key={details.id} pos={index} details={details} sendMessage={sendMessage} displayModal={displayModal} displayMenu={displayMenu} />))}
                {roomListPlayers.map((details, index) => (<UserListElement key={details.id} pos={roomListMobs.length + index} sendMessage={sendMessage} details={details} displayMenu={displayMenu}/>))}
            </div>
            {rightClickMenu !== null && (
                <UserListMenu 
                    x={rightClickMenu.x} 
                    y={rightClickMenu.y} 
                    sendMessage={sendMessage} 
                    details={rightClickMenu.details} 
                    index={rightClickMenu.pos} 
                    hideMenu={hideMenu}
                    characterId={characterId}
                />
            )}
        </div>
    );
}

export default UserList;